import styled, { css, keyframes } from 'styled-components'
import Button from '../../../../../../components/Form/Button'
import Input, { ErrorMessage } from '../../../../../../components/Form/Input'

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => gap || '19px'};

  input:-internal-autofill-selected {
    background-color: #fff;
  }
  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #808080 #DFE9EB;
  }

  /* Chrome, Edge and Safari */
  *::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  *::-webkit-scrollbar-track {
    border-radius: 6px;
    background-color: #DFE9EB;
  }

  *::-webkit-scrollbar-track:hover {
    background-color: #B8C0C2;
  }

  *::-webkit-scrollbar-track:active {
    background-color: #B8C0C2;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #808080;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: #6A6A6A;
  }

  *::-webkit-scrollbar-thumb:active {
    background-color: #6A6A6A;
  }
`
export const ScrollWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 19px;
  max-height: calc(100vh - 342px);
  overflow-y: auto;
  padding: 8px 24px 0 24px;
`
export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  input {
    mask: none;
  }
`
export const EmailWrapper = styled.div`
  width: 100%;
  ${({ disabled }) => disabled && css`
    pointer-events: none;
    input {
      border-color: #DADADA;
      color: #DADADA;
      &::placeholder {
        color: #DADADA;
      }
    }
    label {
      color: #DADADA;
    }
  `}
`
export const StyledInput = styled(Input)`
  & ~ ${ErrorMessage} {
    position: relative;
    bottom: initial;
  }
  ${({ noShowErrorMessage }) => noShowErrorMessage && css`
    & ~ ${ErrorMessage} {
      display: none;
    }
  `}
`

export const AlertEmail = styled.div`
  margin-top: -14px;
`
export const AlertCpf = styled.div`
  margin-top: -8px;
`
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 0 24px 24px 24px;
`
export const SpinnerButtonText = styled.span`
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  vertical-align: text-bottom;
  border: .15em solid;
  border-right: .25em solid transparent;
  border-radius: 50%;
  animation: ${rotate} .5s linear infinite;
  color: #fff;
`
export const SpinnerButton = styled(Button)`
  &:focus,
  &:active {
    box-shadow: 0px 0px 0px 3px rgba(0, 156, 166, 0.40);
  }
  ${Spinner} {
    display: none;
  }
  ${({ loading }) => loading && css`
    ${SpinnerButtonText} {
      display: none;
    }
    ${Spinner} {
      display: block;
    }
  `}
`
